import React, { useEffect, useState } from 'react';
import { getDocSheetOpen } from '../../../utils/docSheetPresence';
import { DocSheetCloseButton } from '../DocSheetCloseButton';
import BrowseView from './BrowseView';
import './styles/popup.css';

/**
 * Finder-style folder window over Atlas.
 * Chrome matches the mission full-view modal (surface, radius, close, motion).
 */
const BrowsePopup = ({
  folderId,
  organization,
  docs,
  onNavigateFolder,
  onOpenDoc,
  onOpenDocInNewTab,
  onCreateDoc,
  createDoc,
  onClose,
}) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const raf = requestAnimationFrame(() =>
      requestAnimationFrame(() => setOpen(true))
    );
    return () => cancelAnimationFrame(raf);
  }, []);

  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key !== 'Escape') return;
      if (getDocSheetOpen()) return;
      e.preventDefault();
      onClose?.();
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [onClose]);

  return (
    <div className={`docs-browse-popup${open ? ' docs-browse-popup--open' : ''}`}>
      <button
        type="button"
        className="docs-browse-popup__backdrop"
        aria-label="Close browse"
        onClick={onClose}
      />
      <div
        className="docs-browse-popup__panel"
        role="dialog"
        aria-modal="true"
        aria-label="Browse folder"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="docs-browse-popup__panel-inner">
          <BrowseView
            variant="popup"
            organization={organization}
            docs={docs}
            folderId={folderId}
            onNavigateFolder={onNavigateFolder}
            onOpenDoc={onOpenDoc}
            onOpenDocInNewTab={onOpenDocInNewTab}
            onCreateDoc={onCreateDoc}
            createDoc={createDoc}
            headerEnd={<DocSheetCloseButton onClose={onClose} />}
          />
        </div>
      </div>
    </div>
  );
};

export default BrowsePopup;
